module.exports = __webpack_public_path__ + "img/logo-en.a0d9d1fb.png";